import * as React from "react";
import "./style.scss";
import image from "../../images/NEW_AboutSection_HomepageGraphic-01.png";
import {StaticImage} from "gatsby-plugin-image";

export default function IntroSection ({children}){
    return <section className={"split-section"}>
        {children}
        <div className="text">
            <h2 className={"italic"}>
                Hi! I'm Lauren Staser.
            </h2>
            <p>
                I’m an illustrator and designer who loves
                <br/>
                helping my clients communicate their
                <br/>
                stories through strategic, artful visuals.
                <br/>
                Check out some of my work below!
            </p>
        </div>
        <StaticImage src={"../../images/NEW_AboutSection_HomepageGraphic-01.png"} alt={""}/>
    </section>
}